var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 7.4375H1.8375C1.06167 7.4375 0.4375 6.81333 0.4375 6.0375V1.8375C0.4375 1.06167 1.06167 0.4375 1.8375 0.4375H6.0375C6.81333 0.4375 7.4375 1.06167 7.4375 1.8375V2.1875M5.3375 3.9375H9.5375C9.9088 3.9375 10.2649 4.085 10.5274 4.34755C10.79 4.6101 10.9375 4.9662 10.9375 5.3375V9.5375C10.9375 9.9088 10.79 10.2649 10.5274 10.5274C10.2649 10.79 9.9088 10.9375 9.5375 10.9375H5.3375C4.9662 10.9375 4.6101 10.79 4.34755 10.5274C4.085 10.2649 3.9375 9.9088 3.9375 9.5375V5.3375C3.9375 5.15365 3.97371 4.9716 4.04407 4.80174C4.11442 4.63189 4.21755 4.47755 4.34755 4.34755C4.47755 4.21755 4.63189 4.11442 4.80174 4.04407C4.9716 3.97371 5.15365 3.9375 5.3375 3.9375Z",
    stroke: "#262F5F",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.de4fa9a30e86f58205cc9e4aba2228ff.svg";
export { ForwardRef as ReactComponent };